import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Dialog,
  DialogContent,
  DialogContentText,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useCreateCardDetailContext } from "../../../CreatecardDetailContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { useQuantityContext } from "../../../QuantityContext";
import { useUserDetailContext } from "../../../UserDetailContext";
import { ReactComponent as VerifiedTick } from "../../../../Assets/img/icons/verified-tick.svg";
import loaderGif from "../../../../Assets/img/icons/Animation - 1718370478484.gif";
import { getAllCardDetailsReducer, getAllCardInfoReducer, patchProfessionalCardReducer, postCreateCardWithNewExperienceReducer } from "../../../../Redux/Reducers/CardReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const ProfessDetails = ({ handleSuccess, handleFailure }) => {
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };
  const { userDetails } = useUserDetailContext();
  const dispatch = useDispatch();
  const { cardDetails, updateCardDetails, ContactStyles, setContactStyles } = useCreateCardDetailContext();
  const { setisNavigationBlocked, openSnackbar, handleInfo } = useQuantityContext();
  const [errorMsg1, setErrorMsg1] = useState(false);
  const [errorMsg2, setErrorMsg2] = useState(false);
  const updateContactValue = (fieldName, newValue) => {
    setContactStyles((prevState) => ({
      ...prevState,
      [fieldName]: newValue,
    }));
    updateCardDetails({ ["is_professional_verified"]: true });
  };

  const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

  const filteredCardName = Allcards?.filter(
    (card) =>
      card?.card_name?.toLowerCase()?.trim() ===
      cardDetails?.CardName?.toLowerCase()?.trim()
  );
  const [loading, setLoading] = useState(false);

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    updateCardDetails({ [fieldName]: newValue });
  };

  const [SaveEnable, setSaveEnable] = useState(false);
  const [initialCardDetails, setInitialCardDetails] = useState({}); // Define initialCardDetails here

  useEffect(() => {
    setInitialCardDetails(cardDetails);
  }, []);

  useEffect(() => {
    setSaveEnable(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
    setisNavigationBlocked(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
  }, [cardDetails, initialCardDetails]);


  const handleSave = async (event) => {
    event.preventDefault();
    if (
      cardDetails?.CardType?.startsWith("Customize_") &&
      (cardDetails.CardName === "" || cardDetails.CardName === null)
    ) {
      // alert("CardName should not be Empty");
      handleInfo("CardName should not be Empty");
      return;
    }
    try {
      // const response = await axios.post(
      //   `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
      //   cardDetails,
      //   {
      //     headers: headers,
      //   }
      // );

      const formData = new FormData();

      const appendIfDefined = (key, value) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      };

      appendIfDefined('User_ID', cardDetails?.User_ID);
      appendIfDefined('CardType', cardDetails?.CardType);
      appendIfDefined('CardName', cardDetails?.CardName);
      appendIfDefined('employee_id', cardDetails?.employee_id);
      appendIfDefined('company_id', cardDetails?.company_id);
      appendIfDefined('location', cardDetails?.location);
      appendIfDefined('location_type', cardDetails?.location_type);
      appendIfDefined('details', cardDetails?.summary);
      appendIfDefined('start_month', cardDetails?.start_month || "");
      appendIfDefined('end_month', cardDetails?.end_month || "");
      appendIfDefined('is_currently_working', cardDetails?.is_experience_current === true ? true : true);
      // appendIfDefined('responsibility', cardDetails?.responsibility.join(", "));
      appendIfDefined(
        'responsibility',
        Array.isArray(cardDetails?.responsibility)
          ? cardDetails.responsibility.join(", ")
          : cardDetails?.responsibility || ""
      );
      appendIfDefined('experience_id', cardDetails?.experience_id || "");
      appendIfDefined('desc', cardDetails?.summary);

      appendIfDefined('employee_type', cardDetails?.employee_type || "");
      appendIfDefined('profession_department', cardDetails?.profession_department);
      appendIfDefined('profession_id', cardDetails?.profession_id);
      appendIfDefined('company_website', cardDetails?.company_website);
      appendIfDefined('institute_domain', cardDetails?.institute_domain);
      appendIfDefined('is_professional_verified', cardDetails?.is_professional_verified);
      appendIfDefined('profile_headline', cardDetails?.profile_headline);
      appendIfDefined('professional_details_status', cardDetails?.professional_details_status);
      appendIfDefined('student_id', cardDetails?.student_id);
      appendIfDefined('student_email_id', cardDetails?.student_email_id);
      // appendIfDefined('student_year', cardDetails?.student_year);
      appendIfDefined('end_year', cardDetails?.is_currently_working ? new Date().getFullYear() : cardDetails?.end_year);
      appendIfDefined('start_year', cardDetails?.start_year);
      appendIfDefined('student_currently_pursuing', cardDetails?.student_currently_pursuing ? 1 : 1);
      appendIfDefined('educational_level', cardDetails?.education_level);
      appendIfDefined('institute_name', cardDetails?.institute);
      appendIfDefined('board', cardDetails?.board);
      appendIfDefined('degree', cardDetails?.degree);
      appendIfDefined('field_of_study', cardDetails?.field_of_study);
      appendIfDefined('percentage', cardDetails?.grade);
      appendIfDefined('university_website', cardDetails?.university_website);
      appendIfDefined('is_student_verified', cardDetails?.is_student_verified ? 1 : 0);
      appendIfDefined('student_details_status', cardDetails?.student_details_status);
      appendIfDefined('prefix', cardDetails?.prefix);
      appendIfDefined('suffix', cardDetails?.suffix);
      appendIfDefined('title', cardDetails?.title);
      appendIfDefined('nickname', cardDetails?.nickname);
      appendIfDefined('education_id', cardDetails?.education_id);
      appendIfDefined('summary', cardDetails?.summary);

      appendIfDefined('role_title', cardDetails?.designation);
      appendIfDefined('designation', cardDetails?.designation);
      appendIfDefined('company_name', cardDetails?.company);
      appendIfDefined('professional_email_id', cardDetails?.professional_email_id);

      if (cardDetails?.additionalFields) {
        Object.entries(cardDetails?.additionalFields).forEach(([key, value]) => {
          appendIfDefined(`additionalFields[${key}]`, value);
        });
      }

      if (cardDetails?.profile_pic) {
        try {
          const response = await fetch(cardDetails?.profile_pic);
          const blob = await response.blob();
          appendIfDefined('profile_pic', blob);
        } catch (error) {
          console.log("API Error", error);
        }
      }




      if (cardDetails?.logo) {
        const logoUrl = cardDetails?.logo?.data || cardDetails?.logo;

        if (logoUrl.startsWith("blob:")) {
          setLoading(true);
          handleInfo("Please wait to complete the process");

          try {
            const response = await fetch(logoUrl);
            const blob = await response.blob();
            const file = new File([blob], cardDetails?.logo?.name, { type: cardDetails?.logo?.type });
            appendIfDefined("logo_file", blob, cardDetails?.logo?.name);
          } catch (error) {
            console.error("Error fetching File", error);
          }

          setLoading(false);
        } else {
          appendIfDefined("logo", logoUrl);
        }
      }

      const resolvedCardId = isNaN(cardDetails?.card_id)
        ? filteredCardName?.[0]?.id
        : cardDetails?.card_id;


      const response = await dispatch(patchProfessionalCardReducer({
        id: Number(resolvedCardId), data: formData
      }));
      console.log("RESPONSE IN THE Professional update", response);

      await dispatch(getAllCardDetailsReducer());
      await dispatch(getAllCardInfoReducer());
      setInitialCardDetails(cardDetails);
      handleSuccess();

    } catch (error) {
      console.error("Error submitting card details:", error);
      handleFailure("It will accept only Integers.");
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/card/card-contact`,
        ContactStyles,
        {
          headers: headers,
        }
      );
      console.log("Response from backend:", response.data);
      // handleSuccess();
    } catch (error) {
      console.error("Error submitting card details:", error);
      // handleFailure();
    }
  };

  const [isDialogOldEmail, setisDialogOldEmail] = useState(false);
  const [isDialogNewEmail, setisDialogNewEmail] = useState(false);

  const [emailId, setemailId] = useState(ContactStyles.email);
  const [code, setCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showCodeError, setShowCodeError] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [showCode, setShowCode] = useState(false);
  const [isDomainVerified, setDomainVerified] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [cardNameError, setCardNameError] = useState("");
  const [verifyDisabled, setVerifyDisabled] = useState(false);

  const toggleCodeVisibility = () => {
    setShowCode((prev) => !prev);
  };

  const handlecloseDialog = () => {
    setCode("");
    setErrorMessage("");
    setemailId(ContactStyles.email);
    setisDialogNewEmail(false);
    setisDialogOldEmail(false);
    setVerifyDisabled(false);
  };

  const handleCodeChange = (event) => {
    setCode(event.target.value);
    setShowCodeError(false);
    setErrorMessage("");
  };

  useEffect(() => {
    // Start the timer only when TwoFactorAuthSecondPage becomes true
    const interval = setInterval(() => {
      if (minutes === 0 && seconds === 0) {
        setCode("");
        clearInterval(interval);
      } else {
        // Decrease seconds if greater than 0
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          if (minutes > 0) {
            setMinutes(minutes - 1);
            setSeconds(59); // Reset seconds to 59 when minutes decrease
          }
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  // const SendOtpOldEmail = () => {
  //     if (!emailId) {
  //         alert("Email id is empty")
  //     }
  //     else if (emailId == ContactStyles.email) {
  //         alert("same email")
  //     }
  //     else {
  //         setisDialogOldEmail(true);
  //         setMinutes(0);
  //         setSeconds(60);
  //         axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`, {
  //             email: `${ContactStyles.email}`,
  //         }, { headers: headers })
  //             .then(response => {
  //                 console.log("OTP sent successfully");
  //             })
  //             .catch(error => {
  //                 // Handle error, such as displaying an error message to the user
  //                 console.error("Failed to send OTP:", error);
  //             });
  //     }
  // }

  // const handleCodeSubmitOldEmail = () => {
  //     axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`, {
  //         email: `${ContactStyles.email}`,
  //         otp: code,
  //     }, { headers: headers })
  //         .then(response => {
  //             setCode('');
  //             setErrorMessage('');
  //             console.log("OTP verified successfully");
  //             setisDialogOldEmail(false);
  //             setisDialogNewEmail(true);
  //             sendOtpNewEmail();
  //         })
  //         .catch(error => {
  //             setCode('');
  //             setErrorMessage("Incorrect OTP. Please try again.");
  //             console.error("Failed to verify OTP:", error);
  //         });
  // }

  const sendOtpNewEmail = () => {
    if (!emailId?.includes("@") || emailId?.trim() === "") {
      // alert("enter the valid email");
      setCardNameError("Enter a Valid Email");
    } else {
      setVerifyDisabled(true);
      setCardNameError("");
      SendingOTP();
    }
  };

  const SendingOTP = () => {
    openSnackbar("Sending OTP to your E-mail ID...", "info", 4000);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`,
        {
          email: `${emailId}`,
        },
        { headers: headers }
      )
      .then((response) => {
        setMinutes(0);
        setSeconds(60);
        setisDialogNewEmail(true);
        handleSuccess("OTP Sent to your E-mail ID!", 3000);
        // console.log("OTP sent successfully");
      })
      .catch((error) => {
        // Handle error, such as displaying an error message to the user
        handleFailure("Could not send OTP. Try Again.", 3000);
        console.error("Failed to send OTP:", error);
      });
  };

  // const checkDomainVerification = async (email) => {
  //   setPageLoading(true);
  //   try {
  //     const domain = email.split("@")[1];
  //     const response = await fetch(
  //       `https://logoapi.onrender.com/logo?domain=${domain}`,
  //       {
  //         method: "GET", // Adjust method if necessary
  //       }
  //     ).then((res) => res.json());

  //     // console.log("Response", response);

  //     if (response.logo) {
  //       const fetchedLogo = response.logo;


  //       let bloblogo;
  //       if (fetchedLogo) {
  //         const payloadlogo = {
  //           logo: fetchedLogo, // Include the logo URL
  //         };

  //         bloblogo = await axios.post(
  //           `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url-from-url`,
  //           payloadlogo,
  //           {
  //             headers: headers,
  //           }
  //         );
  //       }
  //       // console.log("blob url", bloblogo);

  //       const payload = { ...cardDetails, logo: bloblogo?.url };
  //       // const payload = {
  //       //   ...cardDetails,
  //       //   logo: fetchedLogo,
  //       // };
  //       try {
  //         const logoResponse = await axios.post(
  //           `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
  //           payload,
  //           {
  //             headers: headers,
  //           }
  //         );

  //         // console.log("Logo Response", logoResponse);
  //         if (logoResponse.status === 201) {
  //           console.log("Logo is updated");
  //           updateCardDetails({ logo: fetchedLogo });
  //         }
  //       } catch (error) {
  //         console.log("Could not set the fetched logo:", fetchedLogo);
  //       }
  //     }

  //     if (response.data.isDomainVerified) {
  //       setDomainVerified(true);
  //       return true;
  //     }
  //     return false;
  //   } catch (error) {
  //     console.error("Failed to check domain verification:", error);
  //     return false;
  //   } finally {
  //     setPageLoading(false);
  //   }
  // };

  //   const updateLogoInCard = async (email) => {
  //     try {
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_BACKEND_URL}/verify/update-company-logo`,
  //         {
  //           email: email,
  //           cardName: cardDetails.CardName,
  //           cardType: cardDetails.CardType,
  //         },
  //         { headers: headers }
  //       );
  //     } catch (error) {
  //       console.error("Failed to check domain verification:", error);
  //     }
  //     return true;
  //   };

  const handleCodeSubmitNewEmail = async () => {
    try {
      // Proceed with OTP verification
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`,
          {
            email: emailId,
            otp: code,
          },
          { headers: headers }
        )
        .then(async (response) => {
          setCode("");
          setErrorMessage("");
          setisDialogNewEmail(false);
          // const domainVerified = await checkDomainVerification(emailId);
          // console.log("checking domain:", domainVerified);
          console.log("checking response:", response);

          //   if (domainVerified) {
          updateCardDetails({ professional_email_id: emailId });
          console.log("OTP verified successfully");
          // await updateLogoInCard(emailId);
          updateContactValue("email", emailId);
          setVerifyDisabled(false);
          //   } else {
          //     setErrorMessage(
          //       "Domain is not verified. Please use a Correct Professional email."
          //     );
          //   }
        })
        .catch((error) => {
          setErrorMessage("Incorrect OTP. Please try again.");
          console.error("Failed to verify OTP:", error);
          setVerifyDisabled(false);
        });
    } catch (error) {
      console.error("Error in domain verification or OTP submission:", error);
    }
  };

  // if (pageLoading) {
  //   return (
  //     <div className="loader-container">
  //       <img src={loaderGif} alt="Loading..." height={100} width={100} />
  //     </div>
  //   );
  // }

  return (
    <div>
      <div>
        {/* <Box className='my-4 card-info-box' sx={{ border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, paddingTop: "16px" }}> */}
        <div style={{ paddingRight: "16px", paddingLeft: "16px" }}>
          <div className="card-edit-info-heading">
            <h5>Professional Details</h5>
            <span>
              Please note that this information won't appear on the card while
              sharing
            </span>
            <p className="text-display-details">
              *Confidential information, share options not available{" "}
            </p>
          </div>

          <div className="my-2 user-details-container">
            <Grid container spacing={2}>
              {/* First Row */}
              <Grid item xs={6}>
                <TextField
                  label="Employee ID"
                  fullWidth
                  value={cardDetails?.employee_id || ""}
                  onChange={handleInputChange("employee_id")}
                  inputProps={{ maxLength: 18 }}
                />

              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Company CIN/ UIN"
                  fullWidth
                  value={cardDetails?.company_id || ""}
                  onChange={handleInputChange("company_id")}
                  inputProps={{ maxLength: 18 }}
                />

              </Grid>

              {/* Second Row */}
              <Grid item xs={6}>
                <TextField
                  label="Professional Email ID"
                  fullWidth
                  value={emailId || ""}
                  onChange={(e) => {
                    setemailId(e.target.value);
                  }}
                  InputProps={{
                    maxLength: 48,
                    endAdornment: (
                      <InputAdornment position="end">
                        {cardDetails?.is_professional_verified &&
                          ContactStyles.email === emailId ? (
                          <VerifiedTick className="green-verified-tick" />
                        ) : (
                          <VerifiedTick />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />

                {cardNameError && (
                  <Typography variant="body2" color="error">
                    {cardNameError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6} container alignItems="center">
                {cardDetails?.is_professional_verified ? <Button variant="contained" className="verify-button success-green" disabled>
                  Verified
                </Button> :
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#0044C6" }}
                    onClick={!verifyDisabled ? sendOtpNewEmail : undefined}
                  // disabled={emailId === ContactStyles.email}
                  >
                    Verify
                  </Button>}
              </Grid>
            </Grid>

            <FormControlLabel
              control={<Switch checked={true} />}
              label="Disabled"
            />
          </div>
        </div>
        <div
          className="save-bottom"
          style={{
            textAlign: "right",
            backgroundColor: "#0044C614",
            padding: "12px",
            borderRadius: "0 0 8px 8px",
          }}
        >
          <Button
            variant="contained"
            sx={{ backgroundColor: "#0044C6" }}
            onClick={handleSave}
            disabled={!SaveEnable}
          >
            Save
          </Button>
        </div>
        <ToastContainer toastClassName="email-toast-success" />
        {/* </Box> */}
      </div>

      {/* {isDialogOldEmail &&
                <Dialog
                    open={isDialogOldEmail}
                    // onClose={handleCloseVerifiedDialog}
                    aria-labelledby="Enable 2FA (Two-factor Authentication)"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent className="dialogContainer">
                        <DialogContentText className="dialogText">
                            <div>
                                <p className="mt-10 onboard_header_align">Two-factor Authentication</p>
                                <p className="paragraph-text">Verify your E-mail ID</p>
                                <button type="button" className="lightbox__close" onClick={handlecloseDialog}>&times;</button>
                                <div>
                                    <div className=''>
                                        <div>
                                            <TextField
                                                type={showCode ? "text" : "password"}
                                                value={code}
                                                onChange={handleCodeChange}
                                                error={showCodeError}
                                                helperText={showCodeError ? "Code is required" : ""}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                disabled={minutes === 0 && seconds === 0}
                                                className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""}`}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={toggleCodeVisibility}>
                                                                {showCode ? (
                                                                    <VisibilityIcon />
                                                                ) : (
                                                                    <VisibilityOffIcon />
                                                                )}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>

                                        {errorMessage ? (
                                            <div style={{ color: 'red', marginTop: '10px' }}>
                                                {errorMessage}
                                            </div>
                                        ) : (
                                            <div style={{ marginTop: '10px' }}>
                                            </div>
                                        )}

                                        <div className="justify-content-space-bw-login mt-20">
                                            <div className="resent-otp">
                                                Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                                            </div>

                                            <div className="next-button-container" style={{ gap: "16px" }}>
                                                <button className={`next-btn ${code.trim() === '' ? "disabled" : ""}`}
                                                    type="submit" onClick={handleCodeSubmitOldEmail}
                                                    disabled={code.trim() === ''}>
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                        <div className="resent-otp-design mt-20">
                                            Didn't get the mail? <button className="button-style-height" onClick={SendOtpOldEmail}>RESEND</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            } */}

      {isDialogNewEmail && (
        <Dialog
          open={isDialogNewEmail}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">
                  Two-factor Authentication
                </p>
                <p className="paragraph-text">Verify your new E-mail ID</p>
                <button
                  type="button"
                  className="lightbox__close"
                  onClick={handlecloseDialog}
                >
                  &times;
                </button>
                <div>
                  <div className="">
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""
                          }`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    {errorMessage ? (
                      <div style={{ color: "red", marginTop: "10px" }}>
                        {errorMessage}
                      </div>
                    ) : (
                      <div style={{ marginTop: "10px" }}></div>
                    )}

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}
                        :{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div
                        className="next-button-container"
                        style={{ gap: "16px" }}
                      >
                        <button
                          className={`next-btn ${code?.trim() === "" ? "disabled" : ""
                            }`}
                          type="submit"
                          onClick={handleCodeSubmitNewEmail}
                          disabled={code?.trim() === ""}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail?{" "}
                      <button
                        className="button-style-height"
                        onClick={sendOtpNewEmail}
                      >
                        RESEND
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default ProfessDetails;
